/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S12_HeadingInputs */

const tr_iade_iptal_s12_heading = /** @type {(inputs: Iade_Iptal_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. İade Edilmeyen Bedeller`)
};

const en_iade_iptal_s12_heading = /** @type {(inputs: Iade_Iptal_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Non-Refundable Fees`)
};

const de_iade_iptal_s12_heading = /** @type {(inputs: Iade_Iptal_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Nicht erstattungsfähige Entgelte`)
};

const ru_iade_iptal_s12_heading = /** @type {(inputs: Iade_Iptal_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Невозвращаемые суммы`)
};

/**
* | output |
* | --- |
* | "12. Non-Refundable Fees" |
*
* @param {Iade_Iptal_S12_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s12_heading = /** @type {((inputs?: Iade_Iptal_S12_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S12_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s12_heading(inputs)
	if (locale === "de") return de_iade_iptal_s12_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s12_heading(inputs)
	return tr_iade_iptal_s12_heading(inputs)
});